<template>
  <div>
    <the-header :ceremonies="ceremonies" :allCeremoniesCompleted="allCeremoniesCompleted" @ceremony-completed="updateCeremonies" @ready-to-stream="enableWatchLive" />
    <navi />
    <vid-stream :ceremonies="ceremonies" />
    <prev-ceremonies :ceremonies="ceremonies" />
  </div>
</template>

<script>
import theHeader from '@/components/header'
import navi from '@/components/navigation'
import vidStream from '@/components/stream'
import prevCeremonies from '@/components/completedCeremonies'

export default {
  components: {
    theHeader,
    navi,
    vidStream,
    prevCeremonies
  },
  data () {
    return {
      ceremonies: [
        {
          id: 0,
          readyToStream: false,
          streamingVid: 'https://www.youtube.com/embed/FMYV7rg4cEg',
          gradDate: '2026/05/09 10:00:00',
          gradType: [
            'Credential Ceremony'
          ],
          nextUp: true,
          completed: false
        },
        {
          id: 1,
          readyToStream: false,
          streamingVid: 'https://www.youtube.com/embed/AMwYauiXHf4',
          gradDate: '2026/05/16 08:30:00',
          gradType: [
            'Saturday Morning Ceremony'
          ],
          nextUp: false,
          completed: false
        },
        {
          id: 2,
          readyToStream: false,
          streamingVid: 'https://www.youtube.com/embed/J3btaxPmFec',
          gradDate: '2026/05/16 13:30:00',
          gradType: [
            'Saturday Afternoon Ceremony'
          ],
          nextUp: false,
          completed: false
        }
      ],
      // Sample data for one ceremony
      // ceremonies: [
      //   {
      //     id: 0,
      //     readyToStream: false,
      //     streamingVid: 'https://www.youtube.com/embed/-jBisBrFMss',
      //     gradDate: '2021/12/16 18:30:00',
      //     gradType: [
      //       'Graduate and Undergraduate'
      //     ],
      //     nextUp: true,
      //     completed: false
      //   }
      // ],
      // Sample data for multiple ceremonies
      // ceremonies: [
      //   {
      //     id: 0,
      //     readyToStream: false,
      //     streamingVid: 'https://www.youtube.com/embed/jzoiRA2ZcQE',
      //     gradDate: '2022/05/20 18:00:00',
      //     gradType: ['Graduate Ceremony - All Schools'],
      //     nextUp: true,
      //     completed: false
      //   },
      //   {
      //     id: 1,
      //     readyToStream: false,
      //     streamingVid: 'https://www.youtube.com/embed/PsahtdCuwT4',
      //     gradDate: '2022/05/21 8:00:00',
      //     gradType: [
      //       'Undergraduate Ceremony - School of Social Sciences and Education'
      //     ],
      //     nextUp: false,
      //     completed: false
      //   },
      //   {
      //     id: 2,
      //     readyToStream: false,
      //     streamingVid: 'https://www.youtube.com/embed/OQu6h9QM7TA',
      //     gradDate: '2022/05/21 8:00:00',
      //     gradType: [
      //       'Business and Public Administration - (Bachelor\'s Degrees - 2021)',
      //       'Business and Public Administration - (Master\'s Degrees - 2020 and 2021)',
      //       'Social Sciences and Education - (Doctorate and Master\'s Degrees - 2020 and 2021)'
      //     ],
      //     nextUp: false,
      //     completed: false
      //   },
      //   {
      //     id: 3,
      //     readyToStream: false,
      //     streamingVid: 'https://www.youtube.com/embed/5-xC_Ovlmlk',
      //     gradDate: '2021/05/22 18:00:00',
      //     gradType: [
      //       'Arts and Humanities - (Master\'s Degrees - 2020 and 2021)',
      //       'Natural Sciences, Mathematics, and Engineering (Master\'s Degrees 2020 and 2021)',
      //       'Natural Sciences, Mathematics, and Engineering (Bachelor\'s Degrees - 2021)',
      //       'Social Sciences and Education - (Master\'s Degrees - 2020 and 2021)'
      //     ],
      //     nextUp: false,
      //     completed: false
      //   },
      //   {
      //     id: 4,
      //     readyToStream: false,
      //     streamingVid: 'https://www.youtube.com/embed/Hfa1gXpIdWo',
      //     gradDate: '2021/05/23 8:00:00',
      //     gradType: [
      //       'Arts and Humanities - (Bachelor\'s Degrees - 2020)',
      //       'Business and Public Administration - (Bachelor\'s Degrees 2020)',
      //       'Natural Sciences, Mathematics, and Engineering - (Bachelor\'s Degrees - 2020)',
      //       'Social Sciences and Education - (Bachelor\'s Degrees - 2020)'
      //     ],
      //     nextUp: false,
      //     completed: false
      //   },
      //   {
      //     id: 5,
      //     readyToStream: false,
      //     streamingVid: 'https://www.youtube.com/embed/cyH_lDm3kuM',
      //     gradDate: '2021/05/23 18:00:00',
      //     gradType: ['Social Sciences and Education - (Bachelor\'s Degrees - 2020)'],
      //     nextUp: false,
      //     completed: false
      //   }
      // ],
      allCeremoniesCompleted: false // Whether or not all ceremonies are completed
    }
  },
  methods: {
    enableWatchLive: function (data) { // Mark upcoming ceremony as ready to stream to enable the "Watch LIVE" button
      console.log('enableWatchLive triggered for ceremony ' + data.id)
      let upcomingCeremony = data // Store the upcoming ceremony data passed from header.vue
      upcomingCeremony.readyToStream = true // Mark upcoming ceremony as ready to stream
    },
    updateCeremonies: function (data) { // Update the previous and upcoming ceremonies after each one is completed
      console.log('updateCeremonies triggered for ceremony ' + data.id)
      let previousCeremony = data // Store the previous ceremony data passed from header.vue
      previousCeremony.readyToStream = false // Mark previous ceremony as no longer ready to stream
      previousCeremony.nextUp = false // Mark previous ceremony as no longer next up
      previousCeremony.completed = true // Mark previous ceremony as completed

      // Mark upcoming ceremony (next item in ceremonies array) as next up
      if ((previousCeremony.id + 1) !== this.ceremonies.length) { // If the previous ceremony wasn't the last one, update the upcoming ceremony
        let nextCeremony = this.ceremonies[previousCeremony.id + 1]
        nextCeremony.nextUp = true
      } else { // Otherwise, if all ceremonies are completed, set allCeremoniesCompleted to true
        this.allCeremoniesCompleted = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/allCeremonies.vue